module.exports = __webpack_public_path__ + "media/assets/images/blog/beta_features-173ba6762c5f8f5a46c59a0b002b5512.jpg";